/**
 * Logger centralizado para CopaGimnasta
 * Solo muestra errores y solo en modo desarrollo.
 * En producción NO muestra absolutamente nada.
 */

const isDev = process.env.NODE_ENV === 'development';

const noop = () => {};

const logger = {
  error: isDev ? console.error.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  log: isDev ? console.log.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};

export default logger;
